import { Flex } from 'antd';
import { WEBSITE_PUBLIC_CDN } from 'util/constants';
import ProductsButton from '@src/components/ui-kit/buttons/ProductsButton';
import { openNewTab } from 'util/helpers';
import { dot } from './svgs';
import styles from './agent-sections.module.css';

export default function CreateAvatarSection() {
  return (
    <Flex
      vertical
      gap={48}
      align='center'
      justify='center'
      className={styles.createAvatarSectionRoot}
      data-cy='agent3d-contact'
    >
      <Flex vertical gap={48} className={styles.createAvatarSectionWrapper}>
        <Flex
          vertical
          gap={24}
          align='start'
          justify='center'
          className={styles.createAvatarSectionTextWrapper}
        >
          <span className={styles.createAvatarSectionTitle}>
            Create AI Avatars in seconds!
          </span>
          <span className={styles.createAvatarSectionText}>
            Design, customize, and deploy AI-powered 3D avatars for business,
            gaming, and marketing out almost instantly
          </span>
        </Flex>
        <ProductsButton
          type='primary'
          style={{ zIndex: 4 }}
          onClick={() =>
            openNewTab(
              'https://calendly.com/ozonetechnologies/free-consult-discovery'
            )
          }
        >
          Learn how
        </ProductsButton>
        <img
          src={`${WEBSITE_PUBLIC_CDN}/small-blue-hair-girl.png`}
          alt='blue hair girl'
          className={styles.createAvatarSectionLeftImage}
        />
        <div className={styles.quickCreation}>{dot} Quick creation</div>
        <img
          src={`${WEBSITE_PUBLIC_CDN}/violet-hair-girl.png`}
          alt='violet hair girl'
          className={styles.createAvatarSectionRightImage}
        />
        <div className={styles.readyForIntegration}>
          {dot} Ready for integration
        </div>
      </Flex>
    </Flex>
  );
}
